import React from 'react';
import styled from 'styled-components/macro';
import { variant } from 'styled-system';

import { trackingId } from '@blueprint/ui';

import Box from '../Box';
import { Link } from '../Typography';
import Icon from '../Icon';

/**
 * create custom Icon
 */
const IconLinkIcon = styled(Icon)(
  variant({
    prop: 'direction',
    scale: 'links.iconLink.icon.direction',
  }),
  variant({
    scale: 'links.iconLink.icon.variantMapping',
  }),
);

/**
 * IconLink
 */
const IconLink = ({
  icon,
  variant = 'body1',
  direction = 'left',
  children,
  iconProps,
  ...rest
}) => {
  // assign the direction
  const startWithIconOnRight = direction === 'right';
  const startWithIconOnLeft = direction === 'left';

  return (
    <Link
      data-testid="IconLink"
      data-trackid={trackingId('IconLink')}
      variant={variant}
      icon={icon}
      {...rest}
    >
      {startWithIconOnRight && <Box as="span">{children}</Box>}
      <IconLinkIcon
        alignItems="center"
        alignSelf="baseline"
        size="100%"
        variant={variant}
        direction={direction}
        name={icon}
        component="span"
        {...iconProps}
      />
      {startWithIconOnLeft && <Box as="span">{children}</Box>}
    </Link>
  );
};

IconLink.defaultProps = {
  variant: 'body1',
  direction: 'left',
};

export default IconLink;
